import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { Grid } from "@mui/material";
import { FileCopyOutlined } from "@mui/icons-material";
import { useRef } from "react";

interface ISocialMediaShareProps {
  shareURL: string;
  title: string;
  closeShareModal: (closeAfterSuccess?: boolean) => void;
}

export const SocialMediaShare: React.FC<ISocialMediaShareProps> = ({
  shareURL,
  title,
  closeShareModal,
}) => {
  return (
    <>
      <Grid container spacing={1} alignItems={"center"}>
        <Grid item>
          <FacebookShareButton
            url={shareURL}
            title={title}
            onShareWindowClose={closeShareModal}
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </Grid>
        <Grid item>
          <TwitterShareButton
            url={shareURL}
            title={title}
            onShareWindowClose={closeShareModal}
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </Grid>
        <Grid item>
          <WhatsappShareButton
            url={shareURL}
            title={title}
            onShareWindowClose={closeShareModal}
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </Grid>
        <Grid item>
          <EmailShareButton
            subject={title}
            body="Hey check this out:"
            separator=" "
            url={shareURL}
            onShareWindowClose={closeShareModal}
            onClick={() => {}}
            openShareDialogOnClick
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </Grid>
        <Grid item>
          <FileCopyOutlined
            onClick={async () => {
              navigator.clipboard
                .writeText(shareURL)
                .then(() => {
                  closeShareModal(true);
                })
                .catch((e) => {
                  console.error(e);
                });
            }}
            className="hoverItem"
          />
        </Grid>
      </Grid>
    </>
  );
};
